var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6585 8.86361C11.6396 6.75805 13.3826 5.73369 13.4623 5.686C12.4752 4.2468 10.9451 4.05016 10.4075 4.03448C9.12246 3.89925 7.87598 4.8034 7.22138 4.8034C6.55372 4.8034 5.54569 4.04754 4.45926 4.06976C3.06122 4.09131 1.75333 4.90074 1.03601 6.15768C-0.444347 8.72054 0.659716 12.4868 2.07801 14.5584C2.78749 15.5729 3.61652 16.7057 4.70163 16.6659C5.76323 16.6221 6.15978 15.9891 7.44089 15.9891C8.71024 15.9891 9.08261 16.6659 10.1893 16.6404C11.3286 16.6221 12.0459 15.6213 12.7306 14.5976C13.5505 13.4347 13.8797 12.2895 13.8928 12.2307C13.866 12.2215 11.6801 11.3873 11.6585 8.86361Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56791 2.67131C10.1389 1.95726 10.5296 0.985818 10.4211 0C9.59469 0.0365844 8.56118 0.571631 7.96603 1.27C7.43948 1.8854 6.96911 2.89408 7.09062 3.84266C8.01895 3.91191 8.9721 3.37425 9.56791 2.67131Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/Apple.772e61b14382f6360a749b9d552d1344.svg";
export { ForwardRef as ReactComponent };